import type { ReactNode } from 'react';
import { BlockRenderer } from '../blocks/BlockRenderer';
import { ServiceLd } from '../seo/jsonld/Service';
import { BreadcrumbListLd } from '../seo/jsonld/BreadcrumbList';

interface PillarPageRendererProps {
  page: {
    blocks: { id: string; type: string; payload: unknown; audienceFilter?: unknown }[];
  } | null;
  pillarLabel: string;
  pillarDescription: string;
  pillarUrl: string;
  fallback?: ReactNode;
}

export function PillarPageRenderer({
  page,
  pillarLabel,
  pillarDescription,
  pillarUrl,
  fallback,
}: PillarPageRendererProps) {
  return (
    <>
      <ServiceLd name={pillarLabel} description={pillarDescription} url={pillarUrl} />
      <BreadcrumbListLd
        items={[
          { name: 'Accueil', url: 'https://solutionecofrance.fr/' },
          { name: pillarLabel, url: pillarUrl },
        ]}
      />
      {page ? (
        <BlockRenderer
          blocks={page.blocks.map((b) => ({
            id: b.id,
            type: b.type,
            payload: b.payload,
            audienceFilter:
              (b.audienceFilter as Parameters<
                typeof BlockRenderer
              >[0]['blocks'][number]['audienceFilter']) ?? null,
          }))}
        />
      ) : (
        (fallback ?? (
          <section className="mx-auto max-w-3xl px-4 py-24 text-center sm:px-6">
            <p className="eyebrow justify-center">Solution Éco France</p>
            <h1 className="h-display mt-3">{pillarLabel}</h1>
            <p className="mx-auto mt-4 max-w-2xl text-lg leading-relaxed text-stone-600">
              {pillarDescription}
            </p>
          </section>
        ))
      )}
    </>
  );
}
